import React from 'react'; 
import FalconComponentCard from 'components/common/FalconComponentCard';
import IconButton from 'components/common/IconButton';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox'; 
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { toast } from 'react-toastify';
import firebase from './../../../firebase';
import {Col} from 'react-bootstrap'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Services = () => {

  const [l, setL] = React.useState(false);
  const [data, setData] = React.useState([]); 
  const [list, setList] = React.useState(true); 
  
 

  const delIt = async (id) => {
    setL(true);
    try {
      firebase.firestore().collection('services').doc(id).update({delete:true}).then((snap)=> {
        toast.success("Le Service a été archiver");
        loadUsers()
      })
    } catch (err) {
      setL(false);
      // eslint-disable-next-line no-console
      console.log(err);
      toast.error("Une erreur s'est produite");
    } 
  };

  const del = (id) => {
    if(confirm(`Êtes vous certain de vouloir archiver le service?`)){
      delIt(id);
    }
  }

  const columns = [
    {
      accessor: 'icon',
      Header: 'Icone',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { icon, link } = rowData.row.original
        return( <> 
        <FontAwesomeIcon icon={icon} />  
          {link && 
            <img src={link} style={{width:30, height:30, background: '#EBEFF7'}}/>}</>
           )
        }
    },
    //  {
    //   accessor: 'category',
    //   Header: 'Catégorie',
    //   headerProps: { className: 'text-900' },
    //   Cell: rowData => {
    //     const { category } = rowData.row.original
    //     return( 
    //       <> 
    //       {category && category.label&& <p>{category.label}</p> } 
    //      </> 
    //        )
    //     }
    // }, 
    {
      accessor: 'title',
      Header: 'Titre',
      headerProps: { className: 'text-900' }
    },
    {
      accessor: 'action',
      Header: 'Action',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { email, id, type } = rowData.row.original
        return(
          <>
          <IconButton  href={`/service/edit/${id}`}
          variant="falcon-default"
          size="sm"
          icon="edit"
          transform="shrink-3"
          className='me-2'
        >
          <span className="d-none d-sm-inline-block ms-1">modifier</span>
        </IconButton> 
        {type !== "admin" && (
          <IconButton  onClick={() => {del(id)}}
          variant="falcon-danger"
          size="sm"
          icon="trash"
          transform="shrink-3"
          className='me-2'
        >
        </IconButton> 
        )}
        </>
        )
      }
    }
  ];

  const loadUsers = () => {
    firebase.firestore().collection('services').get().then((snap)=> {
      let s = [];
       
      snap.forEach((d) => {
        var l = d.data();
        l.id = d.id;
        // console.log(l?.delete)
        if (l?.delete != true){
          s.push(l)
        } 
        
      })
      setData(s); 
 


    }).catch((error) => {
      setL(false); 
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }

  React.useEffect(() => {
    if (data.length === 0){
      loadUsers()
    }
  }, []);

// const data = [
//   {
//     id: '345678',
//     firstName: 'Anna',
//     lastName: 'Anna',
//     email: 'anna@example.com',
//     phone: "06933322525", 
//     type:"modérateur"
//   },
//   {
//     id: '345678',
//     firstName: 'Anna',
//     lastName: 'Anna',
//     email: 'anna@example.com',
//     phone: "06933322525", 
//     type:"admin"
//   },
// ];
 
 
 

function AdvanceTableExample( ) {

  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data}
      sortable
      pagination
      perPage={205}
    > 
      <Col xs={8} sm="auto" className="ms-auto text-end ps-0 mb-3">
      <div id="orders-actions">
      <IconButton  href="/service/new"
        variant="falcon-default"
        size="sm"
        icon="plus"
        transform="shrink-3"
        className='me-2'
      >
        <span className="d-none d-sm-inline-block ms-1">Nouveau</span>
      </IconButton> 
 
 
      <Col xs="auto" sm={6} lg={4}>
          <AdvanceTableSearchBox table/>
        </Col>
    </div>
      </Col>
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: 'fs--1 mb-0 overflow-hidden'
        }}
      />
      <div className="mt-3">
        <AdvanceTableFooter
          rowCount={data.length}
          table
          rowInfo
          navButtons
          rowsPerPageSelection
        />
      </div>
    </AdvanceTableWrapper>
  );
} 


    return (
      
      <>
      {l ? <p>Chargement... </p>: (<FalconComponentCard>
        
        <FalconComponentCard.Header
          title={ "Liste des services"  }
          light={false}
         
          className="border-bottom border-200" noPreview={true} 
        />
        <FalconComponentCard.Body>
          <AdvanceTableExample arch={!list}/>
        </FalconComponentCard.Body>
  
          
      </FalconComponentCard>)}</>
    );
}

export default Services;
